export default __webpack_public_path__ + "static/2-78fd693f5a902fdffe8c4e01ff9a1ae9.jpeg";